import { AppCardBoxLoader, AppNotFoundBox } from "../../../../Libraries";
import { getSupplierById } from "../../../../../api";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { CreateSupplier } from "..";

const EditSupplier = () => {
    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState({});

    useEffect(() => {
        if (id) getSupplier();
        else setLoading(false);
    }, [id]);

    const getSupplier = async () => {
        try {
            const { data } = await getSupplierById(id);
            setItem(data.supplier);
        } catch (err) { }
        finally {
            setLoading(false);
        }
    };


    return loading ?
        <AppCardBoxLoader />
        : item?._id ?
            <CreateSupplier from="edit" item={item} />
            :
            <AppNotFoundBox title='failed_to_load_supplier' />
};

export default EditSupplier;